<template>
  <section class="section popular-services popular-explore">
    <div class="container">
      <!-- Title -->
      <div class="section-heading" data-aos="fade-down">
        <h2>استكشف أشهر السيارات</h2>
        <p>إليك قائمة ببعض أكثر السيارات شهرة حول العالم.</p>
      </div>

      <!-- Tabs -->
      <div class="listing-tabs-group">
        <ul class="nav listing-buttons gap-3">
          <li v-for="type in popularCarsStore.carTypes" :key="type">
            <a
              href="#"
              @click.prevent="setType(type)"
              :class="['car-tab', { active: activeType === type }]"
            >
              <span class="car-label">{{ type }}</span>
            </a>
          </li>
        </ul>
      </div>

      <!-- Cars List -->
        <div class="row">
          <LoaderCard v-if="popularCarsStore.isLoading" :count="6" />
          <CarList v-else :cars="popularCarsStore.carsByType(activeType)" :key="activeType" />
        </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { usePopularCarsStore } from '@/stores/popularCars'
import CarList from '../index-5/CarList.vue'
import LoaderCard from '@/components/common/LoaderCard.vue'

const popularCarsStore = usePopularCarsStore()
const activeType = ref(null)

const setType = (type) => {
  activeType.value = type
}

onMounted(async () => {
  await popularCarsStore.fetchPopularCars()
  if (popularCarsStore.carTypes.length > 0) {
    activeType.value = popularCarsStore.carTypes[0]
  }
})
</script>
<style scoped>
.car-tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap; 
  padding: 8px 16px;
  min-width: 100px; 
  text-align: center;
}

.car-label {
  display: inline-block;
  white-space: nowrap;
}


.car-label,
.car-label:hover,
.car-label:focus {
  background: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  border: none !important;
}

</style>